      varying vec3 vWorldPos;
      varying vec2 vUv;
      varying vec3 vNormalVector;
      varying float vIsFrontFacing;
      
      void main() {
        vUv = uv;
        vec4 worldPos = modelMatrix * vec4(position, 1.0);
        vWorldPos = worldPos.xyz;
        
        // Calculate world space normal
        vNormalVector = normalize(mat3(modelMatrix) * normal);
        
        // Determine if front facing using the camera position
        vec3 cameraPosition = cameraPosition; // Built-in three.js variable
        vec3 viewDirection = normalize(cameraPosition - worldPos.xyz);
        vIsFrontFacing = dot(vNormalVector, viewDirection) > 0.0 ? 1.0 : -1.0;
        
        //gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        csm_PositionRaw = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      }